export default "__VITE_ASSET__0tTxkzOo__"